import { AnyAction } from 'redux'
import { produce } from 'immer'
import { filter, map } from 'lodash'
import { ThunkResult } from '../../store'
import workOrderCalendar from '../../services/workOrderCalendar.service'
import workOrderApi, { WorkOrderData } from '../../apis/workOrder.api'

export type CalendarDate = {
  day: number
  date: string
  workOrders: WorkOrderData[]
  week: {
    name: string
    day: number
  }
}

interface State {
  month: number
  year: number
  dates: (CalendarDate | null)[]
}

const initialState = (): State => {
  const { month, year } = workOrderCalendar.getCurrentMonthAndYear()
  const dates = workOrderCalendar.getDatesInitialData(month, year)
  return {
    month,
    year,
    dates
  }
}

export function listWorkOrders (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { month, year } = getState().workOrderCalendar
    const payload = workOrderCalendar.getStartAndEndDatesFromMonthAndYear(month, year)
    workOrderApi.listBetweenDates(payload, (workOrders) => {
      if (workOrders) dispatch(replaceWorkOrders(workOrders))
    })
  }
}

export const actions = {
  nextMonth: 'workOrderCalendar/nextMonth',
  previousMonth: 'workOrderCalendar/previousMonth',
  replaceWorkOrders: 'workOrderCalendar/replaceWorkOrders'
}

export function nextMonth () {
  return { type: actions.nextMonth }
}

export function previousMonth () {
  return { type: actions.previousMonth }
}

export function replaceWorkOrders (workOrders: WorkOrderData[]) {
  return { type: actions.replaceWorkOrders, workOrders }
}

export default function reducers (state = initialState(), action: AnyAction) {
  switch (action.type) {
    case actions.nextMonth:
      return produce(state, draft => {
        const { month, year } = draft
        const {
          month: nextMonth,
          year: nextYear
        } = workOrderCalendar.getNextMonthAndYear(month, year)
        draft.month = nextMonth
        draft.year = nextYear
        draft.dates = workOrderCalendar.getDatesInitialData(nextMonth, nextYear)
      })
    case actions.previousMonth:
      return produce(state, draft => {
        const { month, year } = draft
        const {
          month: previousMonth,
          year: previousYear
        } = workOrderCalendar.getPreviousMonthAndYear(month, year)
        draft.month = previousMonth
        draft.year = previousYear
        draft.dates = workOrderCalendar.getDatesInitialData(previousMonth, previousYear)
      })
    case actions.replaceWorkOrders:
      return produce(state, draft => {
        draft.dates = map(draft.dates, date => {
          if (date) {
            date.workOrders = filter((action.workOrders as WorkOrderData[]), workOrder => {
              return workOrderCalendar.isDatesEqual(date.date, workOrder.produceAt)
            })
          }
          return date
        })
      })
    default:
      return state
  }
}
